export default {
    open: "Rispondi adesso",
    approve: "Approva ora",
    impersonation: {
        title: "Stai ordinando per conto di «{name}»",
        cta: "Ritorno a me stesso",
    },
    "You have an unapproved orders": "Hai ordini da approvare",
    "You have orders to approve": "Hai ordini da approvare"
}